import DetailPageReviewImages from "./DetailPageReviewImages";
import { ProductRating, ProductReviewPercentage, Review } from "../../../../Redux/products review/types";


const ProductReviews = ({ productrating, productreviewpercentage, productreviews }: { productrating: ProductRating | null, productreviewpercentage: ProductReviewPercentage | null, productreviews: Review[] }) => {

  const formatReviewCount = (count: number): string => {
    if (count >= 1000000) {
      return (count / 1000000).toFixed(2) + 'm';
    } else if (count >= 1000) {
      return (count / 1000).toFixed(2) + 'k';
    }
    return count.toString();
  };

  const getRelativeTime = (date: Date | string): string => {
    const now = new Date();
    const reviewDate = typeof date === 'string' ? new Date(date) : date;
    const diffInMs = now.getTime() - reviewDate.getTime();
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    if (diffInYears > 0) {
      return `${diffInYears} ${diffInYears === 1 ? 'year' : 'years'} ago`;
    } else if (diffInMonths > 0) {
      return `${diffInMonths} ${diffInMonths === 1 ? 'month' : 'months'} ago`;
    } else if (diffInWeeks > 0) {
      return `${diffInWeeks} ${diffInWeeks === 1 ? 'week' : 'weeks'} ago`;
    } else if (diffInDays > 0) {
      return `${diffInDays} ${diffInDays === 1 ? 'day' : 'days'} ago`;
    } else if (diffInHours > 0) {
      return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'} ago`;
    } else if (diffInMinutes > 0) {
      return `${diffInMinutes} ${diffInMinutes === 1 ? 'minute' : 'minutes'} ago`;
    } else {
      return 'Just now';
    }
  };

  // Return null if required data is not available
  if (!productrating || !productreviewpercentage) {
    return null;
  }

  const averageRating = productreviewpercentage.averageRating || 0;
  const totalReviews = productreviewpercentage.totalReviews || 0;
  const ratingRounded = Number(averageRating.toFixed(0));
  const productRatingAverage = productrating.averageRating || 0;


  return (
    <>
      <div className=" display-max">
        <div className=" row d-flex justify-content-start align-items-start px-3">
          <div className=" col-lg-3 position-sticky top-1">
            <div className=" w-100 ">
              <div className=" d-flex align-items-center justify-content-center text-center">
                <div>
                  <img
                    src="../../assets/img/icons/flower-1.png"
                    height="80"
                    alt=""
                  />
                </div>
                <div className=" text-center lh-1">
                  <b className=" text-black fs-1">{productRatingAverage.toFixed(1)}</b>
                </div>
                <div>
                  <img
                    src="../../assets/img/icons/flower-2.png"
                    height="80"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className=" text-center">
              <b className=" text-black fw-normal">Customer Reviews</b>
              <div className="lh-1">
                <b className=" text-black fw-normal text-xs">
                  This product is in the{" "}
                  <b className=" text-black fs-6">top 10%</b> of eligible
                  listings based on ratings, reviews and reliability
                </b>
              </div>
            </div>
            <hr className=" border mt-5 mb-4" />
            <div>
              <b className=" text-black fw-normal">Overall rating</b>
            </div>
            <div className=" mt-n3">
              <div className="progress-wrapper progress-width text-end">
                <div className="progress-info">
                  <div className="progress-percentage">
                    <span className="text-xs font-weight-bold">{productreviewpercentage.ratingDistribution[0].percentage.toFixed(1)}%</span>
                  </div>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${productreviewpercentage.ratingDistribution[0].percentage.toFixed(1)}%` }}
                  ></div>
                </div>
              </div>
              <div className="progress-wrapper progress-width text-end">
                <div className="progress-info">
                  <div className="progress-percentage">
                    <span className="text-xs font-weight-bold">{productreviewpercentage.ratingDistribution[1].percentage.toFixed(1)}%</span>
                  </div>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${productreviewpercentage.ratingDistribution[1].percentage.toFixed(1)}%` }}
                  ></div>
                </div>
              </div>
              <div className="progress-wrapper progress-width text-end">
                <div className="progress-info">
                  <div className="progress-percentage">
                    <span className="text-xs font-weight-bold">{productreviewpercentage.ratingDistribution[2].percentage.toFixed(1)}%</span>
                  </div>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${productreviewpercentage.ratingDistribution[2].percentage.toFixed(1)}%` }}
                  ></div>
                </div>
              </div>
              <div className="progress-wrapper progress-width text-end">
                <div className="progress-info">
                  <div className="progress-percentage">
                    <span className="text-xs font-weight-bold">{productreviewpercentage.ratingDistribution[3].percentage.toFixed(1)}%</span>
                  </div>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${productreviewpercentage.ratingDistribution[3].percentage.toFixed(1)}%` }}
                  ></div>
                </div>
              </div>
              <div className="progress-wrapper progress-width text-end">
                <div className="progress-info">
                  <div className="progress-percentage">
                    <span className="text-xs font-weight-bold">{productreviewpercentage.ratingDistribution[4].percentage.toFixed(1)}%</span>
                  </div>
                </div>
                <div className="progress">
                  <div
                    className="progress-bar bg-dark"
                    role="progressbar"
                    style={{ width: `${productreviewpercentage.ratingDistribution[4].percentage.toFixed(1)}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-8 px-4">
            <div className=" d-flex justify-content-between align-items-start mb-4">
              <div className=" lh-1">
                <b className=" text-black fw-normal fs-3">{formatReviewCount(totalReviews)} Reviews</b>
              </div>
              <div>
                <button className=" btn btn-outline-dark btn-sm border-radius-2xl dropdown-toggle">
                  Most Recent
                </button>
              </div>
            </div>
            <div className=" input-group-text input-group input-group-outline input-group-lg mb-4">
              <input
                type="text"
                className=" form-control"
                placeholder="Search reviews"
              />{" "}
              <span className="input-group-text p-2 cursor-pointer w-auto rounded-circle position-absolute">
                <i className="bi bi-search text-black p-1 text-lg"></i>
              </span>
            </div>

            {productreviews.map((review) => (
            <div className=" mb-4" key={review._id}>
              <div className=" d-flex justify-content-start align-items-center gap-2">
                <div className="avatar avatar-lg rounded-circle">
                  <img src="../../assets/img/team-1.jpg" alt="" />
                </div>
                <div className=" lh-1">
                  <b className=" text-black fw-normal fs-5">{ 'salar'  }</b>
                  <div>
                    <a href=".">
                      <b className=" text-black fw-normal text-xxs">
                        8 years on Salar
                      </b>
                    </a>
                  </div>
                </div>
              </div>
              <div className=" align-items-center">
                {Array.from({ length: review.rating }).map((_, index) => (
                  <i key={index} className="bi bi-star-fill text-black text-xxs"></i>
                ))}
                {Array.from({ length: 5 - review.rating }).map((_, index) => (
                  <i key={index} className="bi bi-star text-black ms-1 text-xxs"></i>
                ))}
                
                  <b className=" text-xs ms-1 text-black-50 fw-normal">
                    - {getRelativeTime((review as any).createdAt || (review as any).reviewDate || new Date())}
                  </b>
              </div>
              <DetailPageReviewImages images={review.images} videos={review.videos} />
              <div className=" mt-2">
                <p className=" text-sm text-black fw-normal">
                {review.description}
                {" "}
                </p>
              </div>
            </div>
            ))}
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" card w-97 mx-auto p-2 border-radius-0 mt-3 mb-3 bg-purple-subtle">
          <div className=" w-100 ">
            <div className=" d-flex align-items-center justify-content-center text-center">
              <div>
                <img
                  src="../../assets/img/icons/flower-1.png"
                  height="60"
                  alt=""
                />
              </div>
              <div className=" text-center lh-1">
                <b className=" text-black fs-1">{productRatingAverage.toFixed(1)}</b>
              </div>
              <div>
                <img
                  src="../../assets/img/icons/flower-2.png"
                  height="60"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className=" text-center">
            <b className=" text-black fw-normal">Customer Reviews</b>
            <div className="lh-1">
              <b className=" text-black fw-normal text-xs">
                This product is in the{" "}
                <b className=" text-black fs-6">top 10%</b> of eligible listings
                based on ratings, reviews and reliability
              </b>
            </div>
          </div>
          <div className=" card w-100 p-2 mt-3 mb-3 border-radius-0">
            <div className=" input-group-text input-group input-group-outline input-group-lg mb-4">
              <input
                type="text"
                className=" form-control"
                placeholder="Search reviews"
              />{" "}
              <span className="input-group-text p-2 cursor-pointer w-auto rounded-circle position-absolute">
                <i className="bi bi-search text-black p-1 text-lg"></i>
              </span>
            </div>
            {productreviews.slice(0, 3).map((review) => (
            <div className=" mb-3" key={review._id}>
              <div className=" d-flex justify-content-start align-items-center gap-2">
                <div className="avatar avatar-lg rounded-circle">
                  <img src="../../assets/img/team-1.jpg" alt="" />
                </div>
                <div className=" lh-1">
                  <b className=" text-black fw-normal fs-5">{"salar"}</b>
                  <div>
                    <a href=".">
                      <b className=" text-black fw-normal text-xxs">
                        8 years on Salar
                      </b>
                    </a>
                  </div>
                </div>
              </div>
              <div className=" align-items-center">
                {Array.from({ length: review.rating }).map((_, index) => (
                  <i key={index} className="bi bi-star-fill text-black text-xxs"></i>
                ))}
                {Array.from({ length: 5 - review.rating }).map((_, index) => (
                  <i key={index} className="bi bi-star text-black ms-1 text-xxs"></i>
                ))}
            
                <b className=" text-xs ms-1 text-black-50 fw-normal">
                  - {getRelativeTime((review as any).createdAt || (review as any).reviewDate || new Date())}
                </b>
              </div>
              <DetailPageReviewImages images={review.images} videos={review.videos} />
              <div className=" mt-2">
                <p className=" text-sm text-black fw-normal">
                  {review.description}
                  {" "}
                </p>
              </div>
            </div>
            ))}
           
            <div className=" mb-4">
              <button className=" btn btn-outline-dark btn-md w-100">
                See all reviews
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductReviews;
